import React from "react";
import { useTheme } from "../context/ThemeContext";
import { Sun, Moon } from "lucide-react";

// Personal appearance control. Changing this only affects the current user —
// their choice is saved to their own profile and never forced on anyone else.
const SWATCHES = {
  cyber:    { label: "Cyber",    hint: "Default · neon glass",     bg: "#0d1a36", ac: "linear-gradient(135deg,#4f6fff,#7b61ff)", ac2: "#7b61ff" },
  clean:    { label: "Clean",    hint: "Light · professional",     bg: "#f6f8fc", ac: "#2563eb", ac2: "#4f6fff" },
  bold:     { label: "Bold",     hint: "Editorial · high-contrast", bg: "#f2eee5", ac: "#f2481e", ac2: "#ff5a2c" },
  terminal: { label: "Terminal", hint: "Dark · developer",         bg: "#0b1120", ac: "#2dd4bf", ac2: "#22d3ee" },
};

export default function ThemePicker() {
  const { brand, setBrand, mode, setMode, BRANDS } = useTheme();

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12 }}>
        {BRANDS.map((key) => {
          const s = SWATCHES[key];
          const on = brand === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => setBrand(key)}
              style={{
                textAlign: "left", cursor: "pointer", padding: 12, borderRadius: 12,
                background: "var(--t-panel-hi)",
                border: on ? "1px solid var(--t-accent)" : "1px solid var(--t-border-soft)",
                boxShadow: on ? "0 0 0 2px var(--t-accent)" : "none",
                transition: "border-color .15s, box-shadow .15s",
              }}
            >
              <div style={{ display: "flex", gap: 5, marginBottom: 9 }}>
                <span style={{ flex: 1, height: 26, borderRadius: 6, background: s.bg, border: "1px solid var(--t-border-softer)" }} />
                <span style={{ flex: 1, height: 26, borderRadius: 6, background: s.ac }} />
                <span style={{ flex: 1, height: 26, borderRadius: 6, background: s.ac2 }} />
              </div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "var(--t-text-primary)" }}>{s.label}</div>
              <div style={{ fontSize: 11.5, color: "var(--t-text-label)", marginTop: 1 }}>{s.hint}</div>
            </button>
          );
        })}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 16 }}>
        <span style={{ fontSize: 13, color: "var(--t-text-label)", fontWeight: 600 }}>Mode</span>
        {["dark", "light"].map((m) => {
          const on = mode === m;
          return (
            <button
              key={m}
              type="button"
              onClick={() => setMode(m)}
              style={{
                display: "flex", alignItems: "center", gap: 6, cursor: "pointer",
                padding: "8px 14px", borderRadius: 999, fontSize: 13, fontWeight: 600,
                color: on ? "#fff" : "var(--t-text-body)",
                background: on ? "var(--t-accent-grad)" : "var(--t-panel-hi)",
                border: on ? "1px solid var(--t-accent)" : "1px solid var(--t-border-soft)",
                textTransform: "capitalize",
              }}
            >
              {m === "dark" ? <Moon size={14} /> : <Sun size={14} />} {m}
            </button>
          );
        })}
      </div>
    </div>
  );
}
